/* eslint-disable @typescript-eslint/no-explicit-any */
import { Listbox } from '@headlessui/react'
import clsx from 'clsx'
import { type ReactNode } from 'react'

interface FormSelectItemProps {
  children: ReactNode
  isError?: boolean | string
  disabled?: boolean
  value: any
  onClick?: ((value: string) => void) | null
  placeholder?: string
  className?: string
}

export function FormSelectItem({
  children,
  isError,

  className = 'text-center',
  disabled = false,
  value,
  onClick = null,
}: FormSelectItemProps) {
  return (
    <Listbox.Option
      {...(onClick !== null
        ? {
            onClick: () => {
              onClick(value)
            },
          }
        : {})}
      className={({ selected }) =>
        clsx(
          selected ? '' : '',
          className && className,
          isError ? '!border-states-error' : 'border-primary',
          'p-4 border-b-[1px] text-center mr-3'
        )
      }
      value={value}
      disabled={disabled}
    >
      {children}
    </Listbox.Option>
  )
}

export default FormSelectItem
